import { ListingProfileViewMode } from './listingProfileSaveReadiness'

export const LISTING_PROFILE_PROFILE_SECTION_KEY = 'profile'

export const LISTING_PROFILE_LOCKED_SECTION_SUMMARY =
  'Select a target channel in Profile Configuration to unlock this step.'

export const isCreateListingProfileAwaitingTargetChannel = (
  viewMode: ListingProfileViewMode,
  formTargetPlatformId: number | null | undefined
): boolean => viewMode === 'create' && formTargetPlatformId == null

/** Non-profile sections stay collapsed/disabled until create flow has a target channel. */
export const isListingProfileSectionBlockedWithoutTargetChannel = (
  viewMode: ListingProfileViewMode,
  sectionKey: string,
  formTargetPlatformId: number | null | undefined
): boolean =>
  isCreateListingProfileAwaitingTargetChannel(viewMode, formTargetPlatformId) &&
  sectionKey !== LISTING_PROFILE_PROFILE_SECTION_KEY
